import './App.css';

function App() {
  return (
    <div className="App">
      <h1>TEST CF PAGES</h1>
    </div>
  );
}

export default App;
